const WEBP_CONVERTED_BASES = new Set([
  'service-rolling-shutter-repair',
  'service-motor-repair',
  'service-installation',
  'service-commercial',
  'service-industrial',
  'service-maintenance',
  'service-automatic',
  'area-gachibowli',
  'area-kondapur',
  'area-madhapur',
  'area-kukatpally',
  'area-miyapur',
  'area-banjarahills',
  'project-automatic',
  'project-commercial',
  'project-industrial',
  'project-motor',
  'project-shop',
  'type-fire-rated',
  'type-perforated',
  'type-polycarbonate',
  'type-galvanized-solid'
]);

/**
 * Universal Asset URL Helper
 * Resolves static asset paths accurately across local XAMPP subdirectories and Hostinger production root.
 */
export const getAssetUrl = (rawPath = '') => {
  if (!rawPath) return '';
  if (rawPath.startsWith('http://') || rawPath.startsWith('https://') || rawPath.startsWith('data:')) {
    return rawPath;
  }
  
  // Normalize dot-underscore timestamp typo if present
  let path = rawPath.replace(/\._20261003/g, '_20261003');

  // Normalize converted webp files if .jpg is passed
  const filename = path.split('/').pop() || '';
  const baseName = filename.replace(/\.(jpg|jpeg|png)$/i, '');
  if (WEBP_CONVERTED_BASES.has(baseName)) {
    path = path.replace(filename, `${baseName}.webp`);
  }

  if (path.startsWith('/shutterservices/public/')) {
    return path;
  }
  if (path.startsWith('shutterservices/public/')) {
    return `/${path}`;
  }
  const clean = path.startsWith('/') ? path.slice(1) : path;
  const isXampp = window.location.pathname.startsWith('/shutterservices');
  return isXampp ? `/shutterservices/public/${clean}` : `/${clean}`;
};

export const handleImageError = (e, fallback = 'assets/images/shutter/hero-main.jpg') => {
  if (e?.target) {
    const fallbackUrl = getAssetUrl(fallback);
    if (e.target.src !== fallbackUrl) {
      e.target.src = fallbackUrl;
    }
  }
};

export default getAssetUrl;

